import { FunctionComponent, useRef } from "react";
import { FilterBarProps, Item } from "@components/filter-bar/FilterBar.types";
import { FilterBar } from "@components/filter-bar/FilterBar";

interface AuditLogsFilterProps
  extends Pick<FilterBarProps<AuditLogsFilterValues>, "children"> {}

interface AuditLogsFilterValues {
  startDate?: Date | undefined;
  endDate?: Date | undefined;
}

export const AuditLogsFilter: FunctionComponent<AuditLogsFilterProps> = props => {
  const defaultStartDate = new Date();
  defaultStartDate.setDate(defaultStartDate.getDate() - 1);
  const initialValues = useRef<AuditLogsFilterValues>({
    startDate: defaultStartDate,
    endDate: new Date()
  });

  const items: Item<AuditLogsFilterValues>[] = [
    {
      type: "datesRangePicker",
      name: "datesRangePicker",
      stickItem: true,
      props: {
        id: "auditlogs-filter-dates-range",
        startDateProps: { id: "auditlogs-filter-start-date" },
        endDateProps: { id: "auditlogs-filter-end-date" },
        startDateName: "startDate",
        endDateName: "endDate",
        placeholder: "Date(s)"
      }
    }
  ];

  return (
    <FilterBar {...props} items={items} initialValues={initialValues.current} />
  );
};
